<template>
  <tfoot v-if="rows.length > 0">
    <tr style="background-color: #f2f2f28e">
      <td class="text-center p-3">
        <strong style="font-size: 16px">{{
          getSizeRows > 10 && rows.length > 0
            ? $t('common_words.sub_total')
            : $t('common_words.total_mayus')
        }}</strong>
      </td>
      <td class="text-center p-3">
        <strong style="font-size: 16px">{{
          getFormatNumber(getTotalArea())
        }}</strong>
      </td>
      <td class="text-center" v-for="(ribbon, week) in columns" :key="week">
        <strong style="font-size: 16px">{{
          getTotalColumn(week, ribbon[0])
        }}</strong>
      </td>
      <td class="text-center">
        <strong style="font-size: 16px">{{ getTotal() }}</strong>
      </td>
    </tr>
    <tfoot-totals
      v-if="getSizeRows > 10 && rows.length > 0"
      :totalCoveredAreas="getTotalArea(true)"
      :totalColumns="totalColumns"
      :columns="columns"
      :option="option"
    />
  </tfoot>
</template>
<script>
import { getSumOfValorFromArray } from 'src/util/Util.js';
import Formatter from 'src/class/Formatter';
import MixinMasters from 'src/util/mixinMasters';
import TfootTotals from './TfootTotals.vue';

export default {
  name: 'tfoot-pockets',
  components: {
    [TfootTotals.name]: TfootTotals,
  },
  props: {
    rows: {
      type: Array | Object,
      default: [],
    },
    coveredAreas: {
      type: Array | Object,
      default: [],
    },
    columns: {
      type: Array | Object,
      default: [],
    },
    totalRows: {
      type: Array | Object,
      default: [],
    },
    totalColumns: {
      type: Array | Object,
      default: [],
    },
    option: {
      type: String,
      default: 'byLots',
    },
  },
  computed: {
    getSizeRows() {
      return Object.values(this.totalRows).length;
    },
  },
  mixins: [MixinMasters],
  methods: {
    getFormatNumber(value) {
      return Formatter.formatNumber(value);
    },
    getTotalArea(granTotal = false) {
      if (granTotal)
        return getSumOfValorFromArray(Object.values(this.coveredAreas));
      else {
        const result = this.rows
          .map((item) => item.index)
          .map((index) => {
            try {
              return Object.values(this.coveredAreas)[index];
            } catch (error) {
              return [];
            }
          });
        return getSumOfValorFromArray(result);
      }
    },
    getTotalColumn(week, ribbon) {
      const result = this.rows
        .map((item) => item.numberLot)
        .map((numberLot) => {
          try {
            const filtered =
              this.totalColumns[week][ribbon.color_name][numberLot];
            return Array.isArray(filtered)
              ? getSumOfValorFromArray(filtered)
              : filtered;
          } catch (error) {
            return [];
          }
        });

      let sum = getSumOfValorFromArray(result);
      if (this.option === 'byLotsHa') {
        const area = this.getTotalArea();
        sum = Number(area) > 0 ? sum / area : 0;
      }

      return sum > 0 ? Formatter.formatNumber(sum) : 0;
    },
    getTotal() {
      let total = 0;
      if (this.rows.length === 0) return '';
      const rowsTemp = [];
      Object.entries(this.totalRows).forEach((totalColumns) =>
        rowsTemp.push(totalColumns[1])
      );

      const result = this.rows
        .map((item) => item.index)
        .map((index) => rowsTemp[index]);

      result.forEach((row) => {
        let sum = 0;
        try {
          sum = getSumOfValorFromArray(row);
        } catch (error) {}
        total += sum;
      });

      if (this.option === 'byLotsHa') {
        const area = this.getTotalArea();
        total = Number(area) > 0 ? total / area : 0;
      }

      return total > 0 ? Formatter.formatNumber(total) : 0;
    },
  },
};
</script>
